import React from 'react';
import PropTypes from 'prop-types';
import ComplaintPreviewComponent from '../ComplaintPreview/ComplaintPreview';
import Captcha from '../Captcha/Captcha';
import CheckBox from '../base/Checkbox/LabeledCheckbox';
import Button from '../base/Button/GlyphedButton';
import {LeftGlyph, FloppyDiskGlyph} from '../glyphicons/Glyphicons';
import Loader from '../Loader/Loader';
import LeftRightButtonsPanel from '../Buttons/LeftRightButtonsPanel';
import textTranslates from './translate.json';

const IssueComplaint = ({complaint, complaintPositions, componentsToRender, customer, isIssueComplaintButtonEnable, onIssueComplaintButtonClick, onCaptchaChange, onPreviousWindowButtonClick, onTermOfUseChange, siteKey}) => {
    if (complaint.isIssuing === true) {
        return <div className="col-xs-12"> <Loader /> </div>;
    }
    else {
        return(
            <div className="col-xs-12">
                <ComplaintPreviewComponent
                    complaint={complaint}
                    complaintPositions={complaintPositions}
                    componentsToRender={componentsToRender}
                    customer={customer} />
                <div className="col-xs-12">
                    <div className="col-xs-12">
                        <CheckBox
                            htmlId="terms-and-conditions"
                            name="termOfUse"
                            onChange={onTermOfUseChange}
                            label={textTranslates.termOfUse}
                            value={complaint.isTermOfUseAccepted} />
                    </div>
                    <div className="col-xs-12">
                        <Captcha
                            sitekey={siteKey}
                            onChange={onCaptchaChange}/>
                    </div>
                    <div className="col-xs-12">
                        <LeftRightButtonsPanel
                            leftButtonGlyph={<LeftGlyph className="btn-glyphicon"/>}
                            leftButtonLabel={textTranslates.backButtonLabel}
                            leftButtonName="btnPreviousWindow"
                            leftButtonOnClick={onPreviousWindowButtonClick}
                            rightButtonGlyph={<FloppyDiskGlyph className="btn-glyphicon" />}
                            rightButtonIsDisabled={!isIssueComplaintButtonEnable}
                            rightButtonLabel={textTranslates.issueComplaintButtonLabel}
                            rightButtonName="btnIssueComplaint"
                            rightButtonOnClick={onIssueComplaintButtonClick} />
                    </div>
                </div>
            </div>
        );
    }
};

IssueComplaint.propTypes = {
    complaint: PropTypes.object,
    customer: PropTypes.object,
    complaintPositions: PropTypes.array,
    siteKey: PropTypes.string,
    onCaptchaChange: PropTypes.func,
    onPreviousWindowButtonClick: PropTypes.func,
    isIssueComplaintButtonEnable: PropTypes.bool,
    onIssueComplaintButtonClick: PropTypes.func,
    componentsToRender: PropTypes.array
};

export default IssueComplaint;


// WEBPACK FOOTER //
// ./src/components/IssueComplaint/IssueComplaintComponent.js